<template>
  <ol :class="listClass">
    <li v-for="section in sections" :key="section.id" class="p-table">
      <a class="p-link" :href="`#${section.slug}`">{{ section.title }}</a>
      <user-guide-table-of-contents
        v-if="section.children && section.children.length"
        :sections="section.children"
        :level="level + 1"
      />
    </li>
  </ol>
</template>

<script>
export default {
  name: 'user-guide-table-of-contents',
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    listClass() {
      return this.level === 0 ? 'toc-root' : 'toc-nested'
    }
  }
}
</script>

<style lang="scss" scoped>
.toc-root,
.toc-nested {
  padding-left: 20px;
}

.toc-root {
  margin: 0;
}

.toc-nested {
  margin-top: 4px;
}

.p-table {
  color: $link-color;
  margin-bottom: 6px;
}

.p-link {
  color: $link-color;
  text-decoration: none;
  line-height: 1.45;
}

.p-link:hover {
  text-decoration: underline;
}
</style>
